import React from "react";
import ChrInfoPopover from "../../../../Form/Basic/ChrInfoPopover";
import { getActionsBasedOnPosition } from "../../../../Utils/actionUtils";

/*
props = {
  children: <string | component>
  actions: [{component: <actionComponent>, options: <JSON>}, ...]
  headerClass: <string>,
  helpText: <string>,
  actionsClass: <string>
}
*/

const ChrWidgetHeaderFooterTemplate = (props) => {
  const { headerClass, helpText, wrapperClass, widgetSpecificHeaderClasses } = props;
  let leftActions, rightActions;
  const actionsClassName = props.actionsClass || `px-1 ${props.children ? 'ml-auto' : ''}`;
  if (props.actions) {
    ({ leftActions, rightActions } = getActionsBasedOnPosition(props.actions));
  }
  return (
    <div className={ `p-3 d-flex align-items-center cui-height-55 ${wrapperClass} ${widgetSpecificHeaderClasses || ''}` }>
      { props.children &&
        <div className={ `d-flex align-items-center px-1 ${headerClass}` }>
          { props.children }
          {/* TODO_ADMIN_DASHBOARD_REVAMP: Passing container here to get font color and sizes for management report v2. This can be removed after global font and color change */ }
          {
            helpText && <ChrInfoPopover
              html
              delay={500}
              boundary="body"
              content={ helpText }
              placement="auto"
              container="body"
              additionalIconClass="px-1 text-info"
              trigger="click hover"
            />
          }
        </div>
      }
      {
        props.actions && <div className="d-flex justify-content-between align-items-center flex-grow-1">
          { leftActions && <div className={ actionsClassName }>{ leftActions }</div> }
          { rightActions && <div className={ actionsClassName }>{ rightActions }</div> }
        </div>
      }
    </div>
  );
};

export default ChrWidgetHeaderFooterTemplate;
